import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import {
	googleloginAction,
	loadingToggleAction, loginAction,
	microsoftloginAction
} from '../../store/actions/AuthActions';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../msalconfig';
import { useGoogleLogin } from '@react-oauth/google';
import './registration.css';
import { Footer, LoginHero } from '../components';


function Login(props) {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	let errorsObj = { email: '', password: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [password, setPassword] = useState('');
	const [isLoginClicked, setIsLoginClicked] = useState(false);
	const [rememberMe, setRememberMe] = useState(false); // <-- Add state
	const { instance, accounts } = useMsal();

	const [multiCorporateList, setMultiCorporateList] = useState(null);
	const [verificationToken, setVerificationToken] = useState('');
	const [selectedCorporateId, setSelectedCorporateId] = useState('');
	const [multiCorporateEmail, setMultiCorporateEmail] = useState('');
	const [multiCorporateLoading, setMultiCorporateLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const dispatch = useDispatch();

	// Load remember me status from localStorage on component mount
	useEffect(() => {
		const savedRememberMe = localStorage.getItem('rememberMe');
		sessionStorage.setItem('isFirstSession', 'true');
		if (savedRememberMe === 'true') {
			setRememberMe(true);
		}
	}, []);

	// Update localStorage when remember me state changes
	const handleRememberMeChange = (e) => {
		const checked = e.target.checked;
		setRememberMe(checked);
		if (checked) {
			localStorage.setItem('rememberMe', 'true');
		} else {
			localStorage.removeItem('rememberMe');
		}
	};

	function onLogin(e) {
		const notifyTopRight = (data) => {
			toast.success(`✔️ ${data}`, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: false,
				pauseOnHover: true,
				draggable: true,
			});
		};
		const notifyError = (data) => {
			toast.error(`❌ ${data}`, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
		};
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };
		if (email === '') {
			errorObj.email = 'Email is Required';
			error = true;
		}
		if (password === '') {
			errorObj.password = 'Password is Required';
			error = true;
		}
		setErrors(errorObj);
		if (error) {
			return;
		}
		dispatch(loadingToggleAction(true));
		dispatch(loginAction(email, password, navigate, rememberMe, (multiCorpData) => {
			setMultiCorporateList(multiCorpData.corporates);
			setVerificationToken(multiCorpData.verificationToken);
			setMultiCorporateEmail(multiCorpData.email);
		}));
	}

	const handleSelectCorporate = async (e) => {
		e.preventDefault();
		if (!selectedCorporateId) {
			toast.error('Please select a corporate.');
			return;
		}
		setMultiCorporateLoading(true);
		try {
			const res = await (await import('../../services/AxiosInstance')).default.post(
				`/auth/login/select-corporate`,
				{
					selectedCorporateId,
					verificationToken,
					email: multiCorporateEmail
				}
			);
			const data = res.data;
			if (data && data.accessToken && data.user) {
				// Save token and user as in normal login
				import('../../services/AuthService').then(({ saveTokenInLocalStorage, saveUserDataLocalStorage }) => {
					// Pass API timestamp if available
					const apiTimestamp = data.timestamp || data.issuedAt || data.createdAt;
					saveTokenInLocalStorage(data.accessToken, rememberMe, apiTimestamp);
					saveUserDataLocalStorage(data.user);
					const redirectPath = sessionStorage.getItem('redirectAfterLogin');
					if (redirectPath) {
						sessionStorage.removeItem('redirectAfterLogin');
						navigate(redirectPath, { replace: true });
					} else {
						import('../../utils/userSettings').then(({ getResolvedLandingPage }) => {
							getResolvedLandingPage().then((path) => {
								navigate(path, { replace: true });
							});
						});
					}
				});
			} else {
				toast.error(data.message || 'Failed to login with selected corporate.');
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || err?.message || 'Failed to login with selected corporate.');
		} finally {
			setMultiCorporateLoading(false);
		}
	};

	//googlelogin
	const handleGoogleLoginSuccess = async (response) => {
		const { credential } = response;
		dispatch(googleloginAction(credential, navigate, rememberMe));
	};
	//googlelogin
	const handleGoogleLoginFailure = (error) => {
		console.error('Login failed:', error);
	};
	const login = useGoogleLogin({
		onSuccess: handleGoogleLoginSuccess,
		onError: handleGoogleLoginFailure,
	});
	//microsoftlogin
	const handleMicrosoftLogin = async () => {
		try {
			const response = await instance.loginPopup(loginRequest);
			const idToken = response.idToken;
			console.log("response", response)
			console.log('Microsoft Login Successful:', response.account.username);
			dispatch(microsoftloginAction(idToken, navigate, rememberMe));
		} catch (error) {
			if (error.errorCode === "user_cancelled") {
				console.warn("User cancelled the popup.");
			} else {
				console.error("MSAL Login Error:", error);
			}
		}
	};
	const triggerGoogleLogin = () => {
		setIsLoginClicked(true)
	}
	return (
		<div className="authincation d-flex flex-column flex-column-fluid">
			<ToastContainer />
			<LoginHero />
			<div className="flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden">
				<div className="d-flex justify-content-center h-100 align-items-center">
					<div className="authincation-content style-2">
						<div className="row no-gutters">
							<div className="col-xl-12 tab-content" style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
								<div id="sign-in" className="auth-form   form-validation">
									{multiCorporateList ? (
										<form onSubmit={handleSelectCorporate} className="form-validate">
											<h3 className="text-center mb-4 text-black">Select Corporate</h3>
											<div className="form-group mb-3">
												<label className="mb-1" htmlFor="corporate-select"><strong>Corporate</strong></label>
												<select
													id="corporate-select"
													className="form-control"
													value={selectedCorporateId}
													onChange={e => setSelectedCorporateId(e.target.value)}
												>
													<option value="">-- Select a corporate --</option>
													{multiCorporateList.map(corp => (
														<option key={corp.id || corp.corporateId} value={corp.id || corp.corporateId}>
															{corp.name || corp.corporateName}
														</option>
													))}
												</select>
											</div>
											<div className="text-center form-group mb-3 d-flex w-100 justify-content-center align-items-center">
												<button type="submit" className="auth-button-submit" disabled={multiCorporateLoading}>
													{multiCorporateLoading ? (
														<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													) : null}
													Continue
												</button>
											</div>
										</form>
									) : (
										<form onSubmit={onLogin} className="form-validate">

											<div className="form-group mb-3">
												<label className="mb-1" htmlFor="val-email"><strong>Email</strong></label>
												<div>
													<input type="email" className="form-control"
														value={email}
														onChange={(e) => setEmail(e.target.value)}
													/>
												</div>
												{errors.email && <div className="text-danger fs-12">{errors.email}</div>}
											</div>
											<div className="form-group mb-3">
												<label className="mb-1"><strong>Password</strong></label>
												<div className="position-relative password-input-wrapper">
													<input
														type={showPassword ? "text" : "password"}
														className="form-control"
														value={password}
														onChange={(e) =>
															setPassword(e.target.value)
														}
													/>
													<button
														type="button"
														className="password-toggle-btn"
														onClick={() => setShowPassword(!showPassword)}
													>
														<i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
													</button>
												</div>
												{errors.password && <div className="text-danger fs-12">{errors.password}</div>}
											</div>
											<div className="form-row d-flex justify-content-between mt-4 mb-2">
												<div className="form-group mb-3">
													<div className="custom-control custom-checkbox ml-1">
														<input type="checkbox" className="form-check-input" id="basic_checkbox_1" checked={rememberMe} onChange={handleRememberMeChange} style={{ padding: 0 }} />
														<label className="form-check-label" htmlFor="basic_checkbox_1">Remember Me</label>
													</div>
												</div>
												<div className="form-group mb-3" style={{ marginTop: '3px' }}>
													<Link className='form-check-label' to="/forgot-password">Forgot Password?</Link>
												</div>
											</div>
											<div className="text-center form-group mb-3 d-flex w-100 justify-content-center align-items-center">
												<button type="submit" className="auth-button-submit" disabled={props.showLoading}>
													{props.showLoading ? (
														<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													) : null}
													Sign In
												</button>
											</div>
										</form>
									)}
									<div className="new-account mt-3">
										<p>Don't have an account? <Link className="text-primary" to="/register">Sign up</Link></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		errorMessage: state.auth.errorMessage,
		successMessage: state.auth.successMessage,
		showLoading: state.auth.showLoading,
	};
};
export default connect(mapStateToProps)(Login);
